if (typeof window !== 'undefined' && typeof window.mnsHeaderConfig !== 'undefined') {
    module.exports = window.mnsHeaderConfig;
} else {
    module.exports = {
        "wcsBaseUrl": "/webapp/wcs/stores/servlet/",
        "CMD": {
            "authToken": "MSAuthToken",
            "miniBasket": "MSResMiniBasket",
            "savedBasketDisplay": "MSSavedBasketDisplayCmd",
            "navigation23": "MSTopNavTier3Cmd",
            "countryLinks": "MSResCountryLinks",
            "removeItemMiniBag": "MSOrderItemUpdateCmd"
        },
        "storeId": "10151",
        "langId": "-24",
        "catalogId": "10051"
    }
};


// WEBPACK FOOTER //
// ./src/mns-core-ui-header/templates/header/data/config/app.js